import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  root: {
    '& .MuiFormControl-marginDense': {
      marginBottom: 8,
    },
  },
  icon: {
    position: 'absolute',
    zIndex: 1,
    left: 11,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 22,
    fill: palette.primary.main,
  },
  activeIcon: {
    color: palette.primary.main,
  },
  adornmentIcon: {
    fontSize: 22,
    color: palette.primary.main,
  },
  withAdornment: {
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      marginLeft: 30,
    },
  },
  label: {
    marginBottom: 0,
  },
  labelDense: {
    marginBottom: -7,
  },
  textField: {
    paddingLeft: 40,
    paddingTop: 15.5,
    paddingBottom: 15.5,
    height: 15,
    lineHeight: 'normal',
  },
  textFieldElevated: {
    paddingTop: 14,
    paddingBottom: 17,
  },
}));
